import { useCallback } from 'react';
import api from '@/lib/api';
import useVerifyChecker from '@/shared/checkout/useVerifyChecker';

/**
 * Wrapper CRM do `useVerifyChecker` partilhado — apenas injecta o endpoint
 * `/api/encomendas/verify`. Toda a lógica de debounce, normalização de campos
 * (`spValesPermitidos`, etc) está em
 * `/app/frontend/src/shared/checkout/useVerifyChecker.js`.
 */
export default function useCheckoutVerify({
  cartLength, selectedTransport, selectedPayment, selectedEnvio,
  appliedCreditos, appliedVales, appliedPromo,
  balances,
}) {
  const verifyFn = useCallback(async (p) => {
    const { data } = await api.post('/encomendas/verify', {
      id_tipo_transporte: p.selectedTransport,
      id_tipo_pagamento: p.selectedPayment,
      id_morada_envio: p.selectedEnvio,
      desconto_creditos: p.appliedCreditos,
      desconto_vale: p.appliedVales,
      codigo_promocional: p.appliedPromo,
    });
    if (!data?.success) return null;
    return Array.isArray(data.data) ? data.data[0] : data.data;
  }, []);

  return useVerifyChecker({
    verifyFn,
    inputs: {
      cartLength, selectedTransport, selectedPayment, selectedEnvio,
      appliedVales, appliedCreditos, appliedPromo,
    },
    balances,
  });
}
